import { useGraphQLClient } from '@utils/GraphQLClientProvider'
import { SupporterAutocompleteSearchDocument } from './supporterAutocompleteSearch.generated'
import type { SupporterAutocompleteSearchQuery } from './supporterAutocompleteSearch.generated'

export type SupporterSearchResult = {
  id: string
  firstName: string | null
  lastName: string | null
  fullName: string | null
  email: string | null
  memberOfGroup: boolean
}

export type SupporterSearchOption = {
  value: string
  label: string
  data: SupporterSearchResult
}

type UseSupporterAutocompleteProps = {
  groupId: string
}

export function useSupporterAutocomplete({ groupId }: UseSupporterAutocompleteProps) {
  const client = useGraphQLClient()

  const loadOptions = async (inputValue: string): Promise<SupporterSearchOption[]> => {
    if (inputValue.length < 2) return []

    try {
      const data = await client.request<SupporterAutocompleteSearchQuery>(SupporterAutocompleteSearchDocument, {
        term: inputValue,
        groupId,
      })

      return data.supporterAutocompleteSearch.map((supporter) => ({
        value: supporter.id,
        label: supporter.label,
        data: {
          id: supporter.id,
          firstName: supporter.firstName ?? null,
          lastName: supporter.lastName ?? null,
          fullName: supporter.fullName ?? null,
          email: supporter.email ?? null,
          memberOfGroup: supporter.memberOfGroup,
        },
      }))
    } catch {
      return []
    }
  }

  return { loadOptions }
}
